import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { PaymentActionCompleteComponent } from './payment-action-complete/payment-action-complete.component';
import { PaymentActionComponent } from './payment-action/payment-action.component';
import { PaymentErrorComponent } from './payment-error/payment-error.component';
import { PaymentLayoutComponent } from './payment-layout/payment-layout.component';
import { PaymentLegalEntityComponent } from './payment-legal-entity/payment-legal-entity.component';
import { PaymentRejectionReasonsComponent } from './payment-rejection-reasons/payment-rejection-reasons.component';
import { PaymentRoutingModule } from './payment-routing.module';
import { PaymentTitleSummaryComponent } from './payment-title-summary/payment-title-summary.component';
import { CommissionResolver, CommissionService, CommissionStore, PaymentGuard } from './service';
import { EventModule } from '../event/event.module';
import { CommissionAttachmentResolver } from './service/commission-attachment.resolver';

@NgModule({
    imports: [
        SharedModule,
        PaymentRoutingModule,
        EventModule,
    ],
  declarations: [
    PaymentActionCompleteComponent,
    PaymentActionComponent,
    PaymentErrorComponent,
    PaymentLayoutComponent,
    PaymentRejectionReasonsComponent,
    PaymentTitleSummaryComponent,
    PaymentLegalEntityComponent
  ],
  providers: [
    CommissionResolver,
    CommissionAttachmentResolver,
    CommissionService,
    CommissionStore,
    PaymentGuard,
  ]
})
export class PaymentModule { }



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment.module.ts